var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-bi",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M60.8 337h175v175h-175z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(-178 -986) scale(2.9257)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#18b637",
    d: "m0 337 146.6 87.5L0 512zm293.1 0-146.5 87.5L293 512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf0921",
    d: "m0 337 146.6 87.5L293 337zm0 175 146.6-87.5L293 512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M293.1 337h-27.3L0 495.7V512h27.3l265.8-158.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M197.2 424.5a50.6 50.6 0 1 1-101.2 0 50.6 50.6 0 0 1 101.2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 337v16.3L265.8 512h27.3v-16.3L27.3 337z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cf0921",
    stroke: "#18b637",
    strokeWidth: "1pt",
    d: "m156.5 405.4-6.6.1-3.4 5.6-3.4-5.6-6.5-.1 3.2-5.8-3.2-5.7 6.6-.2 3.4-5.6 3.4 5.7h6.5l-3.1 5.8zm-22 38.2h-6.6l-3.4 5.7-3.4-5.6-6.6-.2 3.2-5.7-3.1-5.8 6.5-.1 3.4-5.6 3.4 5.6 6.6.2-3.2 5.7zm44.6 0h-6.6l-3.4 5.7-3.4-5.6-6.5-.2 3.1-5.7-3.1-5.8 6.6-.1 3.4-5.6 3.4 5.6 6.5.2-3.2 5.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/bi.2c42e12c411a586fa42be17867f18a0c.svg";
export { ForwardRef as ReactComponent };